export default __webpack_public_path__ + "static/media/Figo_Health_FINAL.d42138c8.png";